import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const testimonials = [
	{
		id: 1,
		rating: 5,
		author: 'Hassan M.',
		text: 'Outstanding diagnostic accuracy. They found an electrical issue two other shops missed. Clear communication and fair pricing throughout.',
		service: 'Electrical & Diagnostics',
		url: 'https://maps.app.goo.gl/TUp25rLZUxxKZjAn8',
	},
	{
		id: 2,
		rating: 5,
		author: 'Natalia S.',
		text: 'Full detailing and ceramic coating came out flawless. The finish is mirror-like and the interior feels brand new again.',
		service: 'Detailing & Protection',
		url: 'https://maps.app.goo.gl/TUp25rLZUxxKZjAn8',
	},
	{
		id: 3,
		rating: 5,
		author: 'James T.',
		text: 'Performance tune + intake upgrade completely transformed throttle response. Professional, data-driven approach.',
		service: 'Performance Tuning',
		url: 'https://maps.app.goo.gl/TUp25rLZUxxKZjAn8',
	},
	{
		id: 4,
		rating: 5,
		author: 'Priya K.',
		text: 'Transparent inspection report with photos. Only recommended what was necessary—earned my trust immediately.',
		service: 'Maintenance & Inspection',
		url: 'https://maps.app.goo.gl/TUp25rLZUxxKZjAn8',
	},
	{
		id: 5,
		rating: 5,
		author: 'Omar L.',
		text: 'Quick turnaround on brake service. OEM parts, proper torque documentation, and follow-up after delivery.',
		service: 'Brake Service',
		url: 'https://maps.app.goo.gl/TUp25rLZUxxKZjAn8',
	},
	{
		id: 6,
		rating: 5,
		author: 'Stephanie R.',
		text: 'Air conditioning system restored perfectly—cold again even in peak heat. Professional and efficient.',
		service: 'AC System',
		url: 'https://maps.app.goo.gl/TUp25rLZUxxKZjAn8',
	},
];

function Stars({ count }) {
	return (
		<div className="flex" aria-label={`${count} star rating`}>
			{Array.from({ length: count }).map((_, i) => (
				<svg
					key={i}
					className="w-4 h-4 text-[#F5D313]"
					viewBox="0 0 20 20"
					fill="currentColor"
					role="img"
				>
					<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.785.57-1.84-.197-1.54-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
				</svg>
			))}
		</div>
	);
}

function GoogleGIcon({ className = 'h-5 w-5' }) {
	return (
		<svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
			<path fill="#EA4335" d="M12 11v2.9h6.53c-.2 1.34-.73 2.32-1.53 3.12-.98.98-2.51 2.06-5 2.06-3.98 0-7.1-3.22-7.1-7.18s3.12-7.18 7.1-7.18c2.15 0 3.72.84 4.88 1.93l2.06-2.06C17.97 3.08 15.37 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10c2.94 0 5.43-.96 7.25-2.78 1.87-1.87 2.46-4.52 2.46-6.65 0-.66-.05-1.27-.16-1.82H12Z" />
			<path fill="#34A853" d="M3.89 9.59A7.95 7.95 0 0 1 12 4.82c2.15 0 3.72.84 4.88 1.93l2.06-2.06C17.97 3.08 15.37 2 12 2 7.5 2 3.55 4.95 1.9 9.05l1.99.54Z" />
			<path fill="#FBBC05" d="M12 22c2.94 0 5.43-.96 7.25-2.78 1.87-1.87 2.46-4.52 2.46-6.65 0-.66-.05-1.27-.16-1.82H12v2.9h6.53c-.2 1.34-.73 2.32-1.53 3.12-.98.98-2.51 2.06-5 2.06-3.15 0-5.81-2.06-6.76-4.88l-2.86.74C3.55 19.05 7.5 22 12 22Z" />
			<path fill="#4285F4" d="M21.71 7.25C20.59 4.15 17.64 2 12 2 6.48 2 2 6.48 2 12c0 1.62.39 3.15 1.08 4.5L6 15.76A7.18 7.18 0 0 1 4.9 12c0-3.96 3.12-7.18 7.1-7.18 2.5 0 4.15 1.06 5.12 1.95l2.59-2.6Z" />
		</svg>
	);
}

export default function TestimonialsPage() {
	const { t } = useTranslation();
	const [filters, setFilters] = useState({
		text: '',
		service: 'All',
	});
	const [filtered, setFiltered] = useState(testimonials);

	useEffect(() => {
		let filteredData = testimonials;

		// Filter by text
		if (filters.text) {
			filteredData = filteredData.filter((review) =>
				review.text.toLowerCase().includes(filters.text.toLowerCase())
			);
		}

		// Filter by service
		if (filters.service !== t('testimonials.all')) {
			filteredData = filteredData.filter(
				(review) => review.service === filters.service
			);
		}

		setFiltered(filteredData);
	}, [filters, t]);

	const services = [
		t('testimonials.all'),
		...Array.from(new Set(testimonials.map((r) => r.service))),
	];

	return (
		<>
			<SEO
				title="Customer Reviews - Best Car Garage Ras Al Khor Dubai | Vigor Auto Testimonials"
				description="Real customer reviews for Vigor Auto car garage Ras Al Khor Dubai. See why we're the trusted dealer-alternative for car service, repairs & maintenance. Serving Nad Al Hamar, Al Awir & International City."
				keywords="car garage reviews Ras Al Khor, vigor auto testimonials, car service reviews dubai, best car garage dubai, trusted car repair Ras Al Khor, car service ratings dubai, auto repair customer feedback, car garage testimonials dubai"
			/>
			<div className="bg-slate-50">
				{/* Hero */}
				<section className="pt-20 md:pt-28 pb-8 md:pb-12 bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white relative overflow-hidden">
					<div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_70%_30%,#F5D313,transparent_60%)]" />
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
					<div className="max-w-3xl">
						<p className="uppercase tracking-widest text-xs font-semibold text-[#F5D313]/80">
							{t('testimonials.badge')}
						</p>
						<h1 className="mt-4 text-4xl md:text-5xl font-extrabold tracking-tight leading-tight">
							{t('testimonials.title')}
						</h1>
						<p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed">
							{t('testimonials.subtitle')}
						</p>
							<div className="mt-8">
								<a
									href="https://maps.app.goo.gl/2Drba51R1KKzhbQi8"
									target="_blank"
									rel="noopener noreferrer"
									className="group inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-[#1a73e8] shadow-sm ring-1 ring-slate-200/60 hover:bg-[#f8f9fa] hover:ring-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a73e8] transition-colors"
									aria-label="Write a Google review for Vigor Auto"
								>
									{/* Flat multi-color Google G icon */}
									<svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
										<path fill="#EA4335" d="M12 11v2.9h6.53c-.2 1.34-.73 2.32-1.53 3.12-.98.98-2.51 2.06-5 2.06-3.98 0-7.1-3.22-7.1-7.18s3.12-7.18 7.1-7.18c2.15 0 3.72.84 4.88 1.93l2.06-2.06C17.97 3.08 15.37 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10c2.94 0 5.43-.96 7.25-2.78 1.87-1.87 2.46-4.52 2.46-6.65 0-.66-.05-1.27-.16-1.82H12Z" />
										<path fill="#34A853" d="M3.89 9.59A7.95 7.95 0 0 1 12 4.82c2.15 0 3.72.84 4.88 1.93l2.06-2.06C17.97 3.08 15.37 2 12 2 7.5 2 3.55 4.95 1.9 9.05l1.99.54Z" />
										<path fill="#FBBC05" d="M12 22c2.94 0 5.43-.96 7.25-2.78 1.87-1.87 2.46-4.52 2.46-6.65 0-.66-.05-1.27-.16-1.82H12v2.9h6.53c-.2 1.34-.73 2.32-1.53 3.12-.98.98-2.51 2.06-5 2.06-3.15 0-5.81-2.06-6.76-4.88l-2.86.74C3.55 19.05 7.5 22 12 22Z" />
										<path fill="#4285F4" d="M21.71 7.25C20.59 4.15 17.64 2 12 2 6.48 2 2 6.48 2 12c0 1.62.39 3.15 1.08 4.5L6 15.76A7.18 7.18 0 0 1 4.9 12c0-3.96 3.12-7.18 7.1-7.18 2.5 0 4.15 1.06 5.12 1.95l2.59-2.6Z" />
									</svg>
									<span className="whitespace-nowrap">{t('testimonials.writeReview')}</span>
								</a>
							</div>
						</div>
					</div>
				</section>

				{/* Filter */}
				<section className="py-6 md:py-8 border-b border-slate-200 bg-white/70 backdrop-blur sticky top-0 z-10">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap gap-3 items-center">
						<span className="text-xs font-semibold tracking-wide text-slate-500">
							{t('testimonials.filterBy')}
						</span>
						{services.map((s) => (
							<button
								key={s}
								onClick={() => setFilters((f) => ({ ...f, service: s }))}
								className={`px-4 py-2 rounded-full text-sm font-medium transition border ${
									filters.service === s
										? 'bg-[#F5D313] text-slate-900 border-[#F5D313]'
										: 'bg-white text-slate-600 border-slate-200 hover:border-slate-300'
								}`}
							>
								{s}
							</button>
						))}
						<div className="ml-auto text-xs text-slate-500">
							{t('testimonials.showing')} {filtered.length} {t('testimonials.reviews')}
						</div>
					</div>
				</section>

				{/* Reviews Grid */}
				<section className="py-10 md:py-16 lg:py-24">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
							{filtered.map((review) => (
								<a
									key={review.id}
									href={review.url}
									target="_blank"
									rel="noopener noreferrer"
									className="group block bg-white p-5 rounded-xl shadow-sm border border-slate-200/80 hover:shadow-md hover:border-[#F5D313] transition-all duration-300"
								>
									<div className="flex items-start gap-3 mb-3">
										<div className="shrink-0 h-10 w-10 rounded-full bg-white ring-1 ring-slate-200 flex items-center justify-center shadow-sm">
											<GoogleGIcon className="h-5 w-5" />
										</div>
										<div className="flex-1 min-w-0">
											<p className="font-medium text-slate-900 leading-tight truncate" title={review.author}>{review.author}</p>
											<div className="flex items-center gap-2 mt-1">
												<Stars count={review.rating} />
												<span className="text-[11px] uppercase tracking-wide text-slate-400 font-medium">{review.service}</span>
											</div>
										</div>
									</div>
									<p className="text-slate-700 text-sm leading-relaxed mb-4 line-clamp-6">{review.text}</p>
									<div className="flex items-center justify-between border-t pt-3 border-slate-100">
										<span className="text-[11px] text-slate-400">{t('testimonials.verified')}</span>
										<span className="text-[11px] text-[#1a73e8] opacity-0 group-hover:opacity-100 transition-opacity">{t('common.readMore')} →</span>
									</div>
								</a>
							))}
						</div>
					</div>
				</section>
			</div>
		</>
	);
}
